<template>
  <div class="web-archive-fill-container">

    <div class="steps-container">
      <van-steps :active="active" active-icon="checked" inactive-icon="clock-o" finish-icon="passed">
        <van-step>基本信息</van-step>
        <van-step>既往史</van-step>
        <van-step>家族史</van-step>
        <van-step>体检信息</van-step>
      </van-steps>
    </div>

    <!-- 表单主体 -->
    <van-form ref="archiveForm" @submit="submitForm">
      <van-cell-group inset title="团队信息">
        <van-field v-model="formData.orgName" label="医院" readonly/>
        <van-field
          :rules="[{ required: true, message: '请选择团队', trigger: 'change' }]"
          :value="formData.teamId"
          clickable
          label="团队"
          name="picker"
          placeholder="点击进行选择"
          readonly
          @click="showPickerTeam = true"
        />
        <van-field v-model="formData.manageStaffName" label="建档医生" readonly/>
      </van-cell-group>
      <div v-show="active === 0">
        <van-cell-group v-show="active === 0" inset title="基础信息">
          <van-field
            v-model="formData.sickName"
            :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]"
            label="姓名"  placeholder="请输入姓名"
          />
          <van-field :rules="[{ required: true, message: '请选择性别', trigger: 'change' }]" label="性别"
                     name="formData.sickSex">
            <template #input>
              <van-radio-group v-model="formData.sickSex" direction="horizontal">
                <van-radio name="1">男</van-radio>
                <van-radio name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="formData.identityCardNo"
            :rules="[
                  { required: true, message: '请输入身份证号', trigger: 'blur' },
                  { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号格式不正确', trigger: 'blur' }
                ]"
            label="身份证号" placeholder="请输入身份证号码"
            @blur="validateAndExtractIdCard"
          />
          <van-cell
            :rules="[{ required: true, message: '请选择出生日期', trigger: 'change' }]"
            :value="formData.birthday"
            title="出生日期"
            @click="dateShow1 = true"
          >
            <template #default>
              <span :style="{ color: !formData.birthday ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.birthday || '请选择出生日期' }}
              </span>
            </template>
          </van-cell>
          <van-field
            :rules="[{ required: true, message: '请选择婚姻状况', trigger: 'change' }]"
            label="婚姻状况"
            name="formData.marriage"
          >
            <template #input>
              <van-radio-group v-model="formData.marriage" direction="horizontal">
                <van-radio name="10">未婚</van-radio>
                <van-radio name="21">已婚</van-radio>
                <van-radio name="30">丧偶</van-radio>
                <van-radio name="40">离婚</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <van-field
            :rules="[{ required: true, message: '请选择文化程度', trigger: 'change' }]"
            :value="formData.education"
            clickable
            label="文化程度"
            name="picker"
            placeholder="点击进行选择"
            readonly
            @click="showPickerEducation = true"
          />

          <van-field
            :rules="[{ required: true, message: '请选择民族', trigger: 'change' }]"
            :value="formData.nation"
            clickable
            label="民族"
            name="picker"
            placeholder="点击进行选择"
            readonly
            @click="showPickerNation = true"
          />
          <van-field
            v-model="formData.sickWorkCompany"
            :rules="[{ required: true, message: '请输入工作单位/学校', trigger: 'blur' }]"
            label="工作单位" placeholder="请输入工作单位或学校"
          />
          <van-field
            v-model="formData.zoneCode"
            :rules="[{ required: true, message: '请输入所在居村', trigger: 'blur' }]"
            label="所在居村" placeholder="请输入所在居村"
          />
          <van-field
            v-model="formData.nativePlace"
            :rules="[{ required: true, message: '请输入籍贯', trigger: 'blur' }]"
            label="籍贯" placeholder="请输入籍贯"
          />
          <van-field
            v-model="formData.birthPlace"
            :rules="[{ required: true, message: '请输入出生地', trigger: 'blur' }]"
            label="出生地" placeholder="请输入出生地"
          />
          <van-field
            v-model="formData.sickPhone"
            :rules="[
                  { required: true, message: '请输入本人电话', trigger: 'blur' },
                  { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ]"
            label="本人电话" placeholder="请输入本人电话"
          />
          <van-field
            v-model="formData.sickAddress"
            :rules="[{ required: true, message: '请输入常住地址', trigger: 'blur' }]"
            label="常住地址" placeholder="请输入常住地址"
          />
        </van-cell-group>
        <van-cell-group v-show="active === 0" inset title="紧急联系人">
          <van-field
            v-model="formData.linkmanName"
            :rules="[{ required: true, message: '请输入紧急联系人姓名', trigger: 'blur' }]"
            label="紧急联系人" placeholder="请输入紧急联系人姓名"
          />
          <van-field
            :rules="[{ required: true, message: '请选择与本人关系', trigger: 'change' }]"
            :value="formData.linkmanRelation"
            clickable
            label="与本人关系"
            name="picker"
            placeholder="点击进行选择"
            readonly
            @click="showPickerWith = true"
          />
          <van-field
            v-model="formData.linkmanPhone"
            :rules="[
                  { required: true, message: '请输入联系人电话', trigger: 'blur' },
                  { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ]"
            label="联系人电话"  placeholder="请输入联系人电话"
          />
        </van-cell-group>
      </div>

      <!-- 既往史 -->
      <div v-show="active === 1">
        <van-cell-group v-show="active === 1" inset title="既往史">
          <van-field label="是否有疾病" name="formData.pastNone">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.pastNone === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.pastNone" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="active === 1" inset title="慢性病">
          <van-field label="高血压" name="formData.pastHypertension">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.pastHypertension === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.pastHypertension" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-cell
            :value="formData.pastHypertensionDate"
            title="高血压日期"
            @click="dateShow2 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastHypertensionDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastHypertensionDate || '请选择高血压确诊日期' }}
              </span>
            </template>
          </van-cell>
          <van-field label="糖尿病" name="formData.pastDiabetes">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.pastDiabetes === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.pastDiabetes" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-cell
            :value="formData.pastDiabetesDate"
            placeholder="请选择糖尿病确诊日期"
            title="糖尿病日期"
            @click="dateShow13 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastDiabetesDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastDiabetesDate || '请选择糖尿病确诊日期' }}
              </span>
            </template>
          </van-cell>
          <van-field label="冠心病" name="formData.pastCoronary">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.pastCoronary === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.pastCoronary" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-cell
            :value="formData.pastCoronaryDate"
            placeholder="请选择冠心病确诊日期"
            title="冠心病日期"
            @click="dateShow3 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastCoronaryDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastCoronaryDate || '请选择冠心病确诊日期' }}
              </span>
            </template>
          </van-cell>
          <van-field label="慢性阻塞性肺疾病" name="formData.pastCopd">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.pastCopd === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.pastCopd" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-cell
            :value="formData.pastCopdDate"
            placeholder="请选择慢性阻塞性肺疾病确诊日期"
            title="慢性阻塞性肺疾病日期"
            @click="dateShow4 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastCopdDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastCopdDate || '请选择慢性阻塞性肺疾病确诊日期' }}
              </span>
            </template>
          </van-cell>
          <van-field label="恶性肿瘤" name="formData.pastMalignant">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.pastMalignant === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.pastMalignant" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field
            v-model="formData.pastMalignantCon"
            label="恶性肿瘤名称"
            placeholder="请输入恶性肿瘤名称"
          />
          <van-cell
            :value="formData.pastMalignantDate"
            placeholder="请选择恶性肿瘤确诊日期"
            title="恶性肿瘤日期"
            @click="dateShow5 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastMalignantDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastMalignantDate || '请选择恶性肿瘤确诊日期' }}
              </span>
            </template>
          </van-cell>
          <van-field label="脑卒中" name="formData.pastApoplexy">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.pastApoplexy === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.pastApoplexy" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-cell
            :value="formData.pastApoplexyDate"
            placeholder="请选择脑卒中确诊日期"
            title="脑卒中日期"
            @click="dateShow6 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastApoplexyDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastApoplexyDate || '请选择脑卒中确诊日期' }}
              </span>
            </template>
          </van-cell>
          <van-field label="严重精神障碍" name="formData.pastSchizophrenia">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.pastSchizophrenia === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.pastSchizophrenia" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-cell
            :value="formData.pastSchizophreniaDate"
            placeholder="请选择严重精神障碍确诊日期"
            title="严重精神障碍日期"
            @click="dateShow7 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastSchizophreniaDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastSchizophreniaDate || '请选择严重精神障碍确诊日期' }}
              </span>
            </template>
          </van-cell>
          <van-field label="结核病" name="formData.pastTb">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.pastTb === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.pastTb" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-cell
            :value="formData.pastTbDate"
            placeholder="请选择结核病确诊日期"
            title="结核病日期"
            @click="dateShow8 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastTbDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastTbDate || '请选择结核病确诊日期' }}
              </span>
            </template>
          </van-cell>
          <van-field label="肝炎" name="formData.pastHepatitis">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.pastHepatitis === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.pastHepatitis" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-cell
            :value="formData.pastHepatitisDate"
            placeholder="请选择肝炎确诊日期"
            title="肝炎日期"
            @click="dateShow9 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastHepatitisDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastHepatitisDate || '请选择肝炎确诊日期' }}
              </span>
            </template>
          </van-cell>
          <van-field label="其他法定传染病" name="formData.pastOficiala">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.pastOficiala === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.pastOficiala" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field
            v-model="formData.pastOficialaCon"
            label="其他法定传染病名称"
            placeholder="请输入其他法定传染病名称"
          />
          <van-cell
            :value="formData.pastOficialaDate"
            placeholder="请选择其他法定传染病确诊日期"
            title="其他法定传染病日期"
            @click="dateShow10 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastOficialaDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastOficialaDate || '请选择其他法定传染病确诊日期' }}
              </span>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group v-show="active === 1" inset title="职业病">
          <van-field label="职业病" name="formData.occupationalDisease">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.occupationalDisease === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.occupationalDisease" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field
            v-model="formData.occDiseaseCon"
            label="职业病名称"
            placeholder="请输入职业病名称"
          />
          <van-cell
            :value="formData.occupationalDiseaseDate"
            placeholder="请选择职业病确诊日期"
            title="职业病日期"
            @click="dateShow11 = true"
          >
            <template #default>
              <span :style="{ color: !formData.occupationalDiseaseDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.occupationalDiseaseDate || '请选择职业病确诊日期' }}
              </span>
            </template>
          </van-cell>
          <van-field label="其他" name="formData.pastOther">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.pastOther === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.pastOther" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field
            v-model="formData.pastOtherContent"
            label="其他名称"
            placeholder="请输入其他疾病名称"
          />
          <van-cell
            :value="formData.pastOtherContentDate"
            placeholder="请选择其他疾病确诊日期"
            title="其他日期"
            @click="dateShow12 = true"
          >
            <template #default>
              <span :style="{ color: !formData.pastOtherContentDate ? '#C8C9CC' : '#323233', textAlign: 'left', width: '100%', display: 'block' }">
                {{ formData.pastOtherContentDate || '请选择其他疾病确诊日期' }}
              </span>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group inset title="服药情况">
          <van-field
            v-model="formData.drugName1"
            label="服药情况 (药名 1)"
            placeholder="请输入药物名称"
          />
          <van-field
            v-model="formData.drugUsage1"
            label="服药情况 (用法 1)"
            placeholder="请输入用法用量"
          />
          <van-field
            v-model="formData.drugDosage1"
            label="服药情况 (用量 1)"
            placeholder="请输入每次用量"
          />
          <van-field
            v-model="formData.drugName2"
            label="服药情况 (药名 2)"
            placeholder="请输入药物名称"
          />
          <van-field
            v-model="formData.drugUsage2"
            label="服药情况 (用法 2)"
            placeholder="请输入用法用量"
          />
          <van-field
            v-model="formData.drugDosage2"
            label="服药情况 (用量 2)"
            placeholder="请输入每次用量"
          />
          <van-field
            v-model="formData.drugName3"
            label="服药情况 (药名 3)"
            placeholder="请输入药物名称"
          />
          <van-field
            v-model="formData.drugUsage3"
            label="服药情况 (用法 3)"
            placeholder="请输入用法用量"
          />
          <van-field
            v-model="formData.drugDosage3"
            label="服药情况 (用量 3)"
            placeholder="请输入每次用量"
          />
        </van-cell-group>
      </div>

      <!-- 家族史 -->
      <div v-show="active === 2">
        <van-cell-group inset title="家族史-父亲">
          <van-field label="父亲有无疾病" name="formData.fatherNone">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.fatherNone === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.fatherNone" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有无高血压" name="formData.fatherHypertension">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.fatherHypertension === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.fatherHypertension" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有无糖尿病" name="formData.fatherDiabetes">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.fatherDiabetes === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.fatherDiabetes" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有无冠心病" name="formData.fatherCoronary">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.fatherCoronary === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.fatherCoronary" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有无慢性阻塞性肺疾病" name="formData.fatherAllergy">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.fatherAllergy === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.fatherAllergy" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有无恶性肿瘤" name="formData.fatherMalignant">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.fatherMalignant === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.fatherMalignant" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有无脑卒中" name="formData.fatherStroke">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.fatherStroke === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.fatherStroke" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有严重精神障碍" name="formData.fatherSchizophrenia">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.fatherSchizophrenia === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.fatherSchizophrenia" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有无结核病" name="formData.fatherTb">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.fatherTb === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.fatherTb" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有无肝炎" name="formData.fatherHepatitis">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.fatherHepatitis === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.fatherHepatitis" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有先天畸形" name="formData.fatherCongenital">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.fatherCongenital === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.fatherCongenital" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="父亲有无其他疾病" name="formData.fatherOther">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.fatherOther === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.fatherOther" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field v-show="formData.fatherOther === 1" v-model="formData.fatherOtherContent" label="其他疾病内容"/>
        </van-cell-group>
        <van-cell-group inset title="家族史-母亲">
          <van-field label="母亲有无疾病" name="formData.motherNone">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.motherNone === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.motherNone" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有无高血压" name="formData.motherHypertension">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.motherHypertension === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.motherHypertension" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有无糖尿病" name="formData.motherDiabetes">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.motherDiabetes === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.motherDiabetes" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有无冠心病" name="formData.motherCoronary">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.motherCoronary === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.motherCoronary" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有无慢性阻塞性肺疾病" name="formData.motherAllergy">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.motherAllergy === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.motherAllergy" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有无恶性肿瘤" name="formData.motherMalignant">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.motherMalignant === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.motherMalignant" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有无脑卒中" name="formData.motherStroke">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.motherStroke === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.motherStroke" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有严重精神障碍" name="formData.motherSchizophrenia">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.motherSchizophrenia === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.motherSchizophrenia" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有无结核病" name="formData.motherTb">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.motherTb === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.motherTb" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有无肝炎" name="formData.motherHepatitis">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.motherHepatitis === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.motherHepatitis" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有先天畸形" name="formData.motherCongenital">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.motherCongenital === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.motherCongenital" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="母亲有无其他疾病" name="formData.motherOther">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.motherOther === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.motherOther" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field v-show="formData.motherOther === 1" v-model="formData.motheOtherContent" label="其他疾病内容"/>
        </van-cell-group>
        <van-cell-group inset title="家族史-兄弟姐妹">
          <van-field label="兄弟姐妹有无疾病" name="formData.brothersNone">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.brothersNone === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.brothersNone" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有无高血压" name="formData.brothersHypertension">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.brothersHypertension === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.brothersHypertension" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有无糖尿病" name="formData.brothersDiabetes">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.brothersDiabetes === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.brothersDiabetes" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有无冠心病" name="formData.brothersCoronary">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.brothersCoronary === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.brothersCoronary" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有无慢性阻塞性肺疾病" name="formData.brothersAllergy">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.brothersAllergy === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.brothersAllergy" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有无恶性肿瘤" name="formData.brothersMalignant">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.brothersMalignant === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.brothersMalignant" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有无脑卒中" name="formData.brothersStroke">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.brothersStroke === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.brothersStroke" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有严重精神障碍" name="formData.brothersSchizophrenia">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.brothersSchizophrenia === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.brothersSchizophrenia" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有无结核病" name="formData.brothersTb">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.brothersTb === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.brothersTb" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有无肝炎" name="formData.brothersHepatitis">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.brothersHepatitis === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.brothersHepatitis" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有先天畸形" name="formData.brothersCongenital">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.brothersCongenital === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.brothersCongenital" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="兄弟姐妹有无其他疾病" name="formData.brothersOther">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.brothersOther === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.brothersOther" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field v-show="formData.brothersOther === 1" v-model="formData.brothersOtherContent" label="其他疾病内容"/>
        </van-cell-group>
        <van-cell-group inset title="家族史-子女">
          <van-field label="子女有无疾病" name="formData.childrenNone">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.childrenNone === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.childrenNone" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有无高血压" name="formData.childrenHypertension">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.childrenHypertension === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.childrenHypertension" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有无糖尿病" name="formData.childrenDiabetes">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.childrenDiabetes === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.childrenDiabetes" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有无冠心病" name="formData.childrenCoronary">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.childrenCoronary === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.childrenCoronary" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有无慢性阻塞性肺疾病" name="formData.childrenAllergy">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.childrenAllergy === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.childrenAllergy" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有无恶性肿瘤" name="formData.childrenMalignant">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.childrenMalignant === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.childrenMalignant" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有无脑卒中" name="formData.childrenStroke">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.childrenStroke === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.childrenStroke" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有严重精神障碍" name="formData.childrenSchizophrenia">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.childrenSchizophrenia === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.childrenSchizophrenia" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有无结核病" name="formData.childrenTb">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.childrenTb === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.childrenTb" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有无肝炎" name="formData.childrenHepatitis">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.childrenHepatitis === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.childrenHepatitis" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有先天畸形" name="formData.childrenCongenital">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.childrenCongenital === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.childrenCongenital" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field label="子女有无其他疾病" name="formData.childrenOther">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.childrenOther === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.childrenOther" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field v-show="formData.childrenOther === 1" v-model="formData.childrenOtherContent" label="其他疾病内容"/>
        </van-cell-group>
      </div>

      <!-- 体检信息 -->
      <div v-show="active === 3">
        <van-cell-group inset title="基础信息">
          <van-field v-model="formData.height" label="身高" placeholder="请输入身高"/>
          <van-field v-model="formData.waist" label="腰围" placeholder="请输入腰围"/>
          <van-field v-model="formData.weight" label="体重" placeholder="请输入体重"/>
          <van-field v-model="formData.systolic" label="高压" placeholder="请输入高压"/>
          <van-field v-model="formData.diastolic" label="低压" placeholder="请输入低压"/>
          <van-field v-model="formData.visionLeftEye" label="左眼视力" placeholder="请输入左眼视力"/>
          <van-field v-model="formData.visionRightEye" label="右眼视力" placeholder="请输入右眼视力"/>
          <van-field v-model="formData.straightenVisionLeftEye" label="左眼校正视力" placeholder="请输入左眼校正视力"/>
          <van-field v-model="formData.straightenVisionRightEye" label="右眼校正视力" placeholder="请输入右眼校正视力"/>
          <van-field label="有无残疾情况" name="formData.disabilityWithout">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.disabilityWithout === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.disabilityWithout" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group inset title="日常习惯">
          <van-field label="吸烟状况" name="formData.smokingCircumstance">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.smokingCircumstance === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.smokingCircumstance" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field v-model="formData.dailySmokingQuantity" label="日吸烟只数" placeholder="请输入日吸烟只数"/>
          <van-field v-model="formData.beginSmokingAge" label="开始吸烟年龄" placeholder="请输入开始吸烟年龄"/>
          <van-field v-model="formData.quitSmokingAge" label="戒烟年龄" placeholder="请输入戒烟年龄"/>
          <van-field label="饮酒情况" name="formData.drinkFrequency">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{ formData.drinkFrequency === 1 ? '是' : '否' }}</span>
              <van-switch v-model="formData.drinkFrequency" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field v-model="formData.beginDrinkAge" label="开始饮酒年龄" placeholder="请输入开始饮酒年龄"/>
          <van-field label="是否戒酒" name="formData.isDryOut">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.isDryOut === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.isDryOut" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field v-model="formData.dryOutAge" label="戒酒年龄" placeholder="请输入戒酒年龄"/>
          <van-field label="近一年内是否醉酒" name="formData.oneYearIsTemulentia">
            <template #input>
              <span style="margin-right: 8px; color: #C8C9CC;">{{
                  formData.oneYearIsTemulentia === 1 ? '是' : '否'
                }}</span>
              <van-switch v-model="formData.oneYearIsTemulentia" :active-value="1" :inactive-value="0" size="20"/>
            </template>
          </van-field>
          <van-field v-model="formData.drinkWhiteSpirits" label="饮酒种类" placeholder="请输入饮酒种类(白酒)"/>
          <van-field v-model="formData.drinkBeer" label="饮酒种类" placeholder="请输入饮酒种类(啤酒)"/>
          <van-field v-model="formData.drinkRedWine" label="饮酒种类" placeholder="请输入饮酒种类(红酒)"/>
          <van-field v-model="formData.drinkYellowWine" label="饮酒种类" placeholder="请输入饮酒种类(黄酒)"/>
          <van-field v-model="formData.drinkOthers" label="饮酒种类" placeholder="请输入饮酒种类(其他)"/>
          <van-field v-model="formData.drinkOthersStr" label="饮酒种类" placeholder="请输入饮酒种类(其他描述)"/>
          <van-field v-model="formData.everyAlcoholTolerance" label="每日饮酒量" placeholder="请输入每日饮酒量"/>
          <van-field v-model="formData.hardeningFrequency" label="体育锻炼频率" placeholder="请输入体育锻炼频率"/>
          <van-field v-model="formData.everyHardeningTime" label="每次锻炼时间" placeholder="请输入每次锻炼时间 (分钟)"/>
          <van-field v-model="formData.insistHardeningTime" label="坚持锻炼时间" placeholder="请输入坚持锻炼时间（年）"/>
          <van-field v-model="formData.hardeningMode" label="锻炼方式" placeholder="请输入锻炼方式"/>
        </van-cell-group>

      </div>
      <van-cell-group inset>
        <div class="button-row">
          <van-button v-if="active !== 0" size="large" type="default" native-type="button" @click="stepsMinus">上一步</van-button>
          <van-button v-if="active < 3" size="large" type="primary" native-type="button" @click="stepsPlus">下一步</van-button>
          <van-button v-if="active === 3" size="large" type="primary" native-type="button" @click="submitForm">提交</van-button>
        </div>
      </van-cell-group>
    </van-form>

    <!-- 日期选择器 -->
    <van-calendar
      v-model="dateShow1"
      @confirm="onConfirm1"
      :min-date="new Date(1900, 0, 1)"
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      :show-close="false"
      ref="calendar1"
      @open="currentCalendarIndex = 1"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar1)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择出生日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar1)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow2"
      @confirm="onConfirm2"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar2"
      @open="currentCalendarIndex = 2"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar2)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择高血压确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar2)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow3"
      @confirm="onConfirm3"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar3"
      @open="currentCalendarIndex = 3"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar3)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择冠心病确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar3)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow4"
      @confirm="onConfirm4"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar4"
      @open="currentCalendarIndex = 4"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar4)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择慢性阻塞性肺疾病确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar4)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow5"
      @confirm="onConfirm5"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar5"
      @open="currentCalendarIndex = 5"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar5)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择恶性肿瘤确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar5)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow6"
      @confirm="onConfirm6"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar6"
      @open="currentCalendarIndex = 6"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar6)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择脑卒中确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar6)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow7"
      @confirm="onConfirm7"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar7"
      @open="currentCalendarIndex = 7"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar7)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择严重精神障碍确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar7)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow8"
      @confirm="onConfirm8"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar8"
      @open="currentCalendarIndex = 8"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar8)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择结核病确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar8)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow9"
      @confirm="onConfirm9"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar9"
      @open="currentCalendarIndex = 9"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar9)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择肝炎确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar9)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow10"
      @confirm="onConfirm10"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar10"
      @open="currentCalendarIndex = 10"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar10)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择其他法定传染病确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar10)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow11"
      @confirm="onConfirm11"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar11"
      @open="currentCalendarIndex = 11"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar11)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择职业病确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar11)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow12"
      @confirm="onConfirm12"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar12"
      @open="currentCalendarIndex = 12"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar12)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择其他疾病确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar12)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>
    <van-calendar
      v-model="dateShow13"
      @confirm="onConfirm13"
      :min-date=birthdayMinDate
      :max-date="new Date()"
      :show-subtitle="true"
      :show-confirm="false"
      ref="calendar13"
      @open="currentCalendarIndex = 13"
    >
      <template #title>
        <div class="calendar-title-with-buttons">
          <van-button
            icon="arrow-left"
            size="small"
            @click.stop="changeYear(-1, $refs.calendar13)"
            type="default"
            plain
          />
          <span class="calendar-title-text">选择糖尿病确诊日期</span>
          <van-button
            icon="arrow"
            size="small"
            @click.stop="changeYear(1, $refs.calendar13)"
            type="default"
            plain
          />
        </div>
      </template>
    </van-calendar>


    <!-- 与本人关系 -->
    <van-popup v-model="showPickerWith" position="bottom">
      <van-picker
        :columns="HYGIENE_WITH_HOST_RELATION_DICT_NAME"
        show-toolbar
        @cancel="showPickerWith = false"
        @confirm="pickWithHostRelation"
      />
    </van-popup>

    <!-- 团队 -->
    <van-popup v-model="showPickerTeam" position="bottom">
      <van-picker
        :columns="teamList"
        show-toolbar
        @cancel="showPickerTeam = false"
        @confirm="pickTeam"
      />
    </van-popup>


    <!-- 文化程度 -->
    <van-popup v-model="showPickerEducation" position="bottom">
      <van-picker
        :columns="EDUCATION_NAME"
        show-toolbar
        @cancel="showPickerEducation = false"
        @confirm="pickEducation"
      />
    </van-popup>

    <!-- 职业 -->
    <van-popup v-model="showPickerOccupation" position="bottom">
      <van-picker
        :columns="OCCUPATION_NAME"
        show-toolbar
        @cancel="showPickerOccupation = false"
        @confirm="pickOccupation"
      />
    </van-popup>

    <!-- 民族 -->
    <van-popup v-model="showPickerNation" position="bottom">
      <van-picker
        :columns="NATION_NAME"
        show-toolbar
        @cancel="showPickerNation = false"
        @confirm="pickNation"
      />
    </van-popup>

    <!-- 性别 -->
    <van-popup v-model="showPickerSex" position="bottom">
      <van-picker
        :columns="SEX_NAME"
        show-toolbar
        @cancel="showPickerSex = false"
        @confirm="pickSex"
      />
    </van-popup>

    <!-- 错误提示对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="showErrorDialog"
      title="参数错误"
      width="80%"
    >
      <div class="error-content">
        <p><i class="el-icon-error error-icon"></i> 缺少必要的参数</p>
        <div class="error-details">
          <p v-if="!hasOrgId">缺少医院 ID (orgId)</p>
          <p v-if="!hasManageOperator">缺少建档医生信息 (manageOperator)</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "web-archive-fill",
  data() {
    // 身份证号验证规则
    const validateIdCard = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证号'));
      } else if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        callback(new Error('身份证号格式不正确'));
      } else {
        callback();
      }
    };

    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };

    return {
      // 必要参数
      orgId: '',
      manageOperator: '',

      // 参数检查结果
      hasOrgId: false,
      hasManageOperator: false,
      showErrorDialog: false,
      // 步骤条
      active: 0,
      // 日期选择器
      dateShow1: false, // 出生日期
      dateShow2: false, // 疾病史-高血压
      dateShow3: false, // 疾病史-冠心病
      dateShow4: false, // 疾病史-慢性阻塞性肺疾病
      dateShow5: false, // 疾病史-恶性肿瘤
      dateShow6: false, // 疾病史-脑卒中
      dateShow7: false, // 疾病史-严重精神障碍
      dateShow8: false,  // 疾病史-结核病日期
      dateShow9: false, // 疾病史-肝炎
      dateShow10: false, // 疾病史-其他传染病
      dateShow11: false, // 疾病史-职业病
      dateShow12: false, // 疾病史-其他
      dateShow13: false, // 疾病史-糖尿病
      currentCalendarIndex: null,
      calendarTemp: null,
      birthdayMinDate: new Date(1900, 0, 1),
      //与本人关系
      showPickerWith: false,
      //文化程度
      showPickerEducation: false,
      // 职业
      showPickerOccupation: false,
      // 民族
      showPickerNation: false,
      // 性别
      showPickerSex: false,

      // 医院信息
      orgInfo: null,

      //列表
      teamList: [],                  //团队列表
      showPickerTeam: false,         //团队列表弹窗
      staffList: [],                 //医生列表



      // 与本人关系列表
      HYGIENE_WITH_HOST_RELATION_DICT_NAME:
        [
          "本人", "配偶", "其他情况配偶", "夫", "妻", "子", "儿子", "养子", "女婿", "其他儿子",
          "女", "女儿", "养女", "儿媳", "其他女儿", "孙子、孙女或外孙子、外孙女", "孙子", "孙子",
          "孙女", "外孙子", "外孙女", "孙媳妇", "孙女婿", "曾孙子", "曾孙女", "其他孙子",
          "父母", "父母", "父亲", "母亲", "公公", "婆婆", "岳父", "岳母", "继父", "继母",
          "其他父母关系", "祖父母或外祖父母", "祖父母", "祖父", "祖母", "外祖父", "外祖母",
          "配偶的祖父母", "曾祖父", "曾祖母", "配偶的曾祖父母", "其他祖父母",
          "兄、弟、姐、妹", "兄弟姐妹", "兄", "嫂", "弟", "弟媳", "姐姐", "姐夫", "妹妹", "妹夫",
          "其他兄弟姐妹", "其他", "其他", "伯父", "伯母", "叔父", "婶母", "舅父", "舅母",
          "姨父", "姨母", "姑父", "姑母", "堂兄弟", "表兄弟", "侄子", "侄女", "外甥", "外甥女",
          "其他亲属", "保姆", "非亲属", "集体户口"
        ],
      HYGIENE_WITH_HOST_RELATION_DICT_CODE:
        [
          0, 1, 10, 11, 12, 2, 20, 21, 22, 23,
          3, 30, 31, 32, 33, 4, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
          5, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
          6, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69,
          7, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79,
          8, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
          91, 92, 93, 94, 95, 96, 97, 98, 99,
          13, 14, 15, 16
        ],
      // 文化程度列表
      EDUCATION_NAME:
        [
          '研究生', '大学本科', '大学专科和专科学校', '中等专业学校', '技工学校', '高中',
          '初中', '小学', '文盲或半文盲', '不详'
        ],
      EDUCATION_CODE:
        [
          '8', '6', '5', '9', '10', '4',
          '3', '2', '1', '7'
        ],
      // 职业
      OCCUPATION_NAME: ['党的机关、国家机关、群众团体和社会组织、企事业单位负责人', '专业技术人员', '办事人员和有关人员', '社会生产服务和生活服务人员'
        , '农、林、牧、渔、水利业生产人员', '生产、运输设备操作人员及有关人员', '军人', '不便分类的其他从业人员', '无职业', '学生'],
      OCCUPATION_CODE: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      // 民族
      NATION_NAME: [
        "汉族", "蒙古族", "回族", "藏族", "维吾尔族", "苗族", "彝族", "壮族", "布依族", "朝鲜族",
        "满族", "侗族", "瑶族", "白族", "土家族", "哈尼族", "哈萨克族", "傣族", "黎族", "傈僳族",
        "佤族", "畲族", "高山族", "拉祜族", "水族", "东乡族", "纳西族", "景颇族", "柯尔克孜族", "土族",
        "达翰尔族", "仫佬族", "羌族", "布朗族", "撒拉族", "毛南族", "仡佬族", "锡伯族", "阿昌族", "普米族",
        "塔吉克族", "怒族", "乌孜别克族", "俄罗斯族", "鄂温克族", "德昂族", "保安族", "裕固族", "京族", "塔塔尔族",
        "独龙族", "鄂伦春族", "赫哲族", "门巴族", "珞巴族", "基诺族", "外国血统", "其他"
      ],
      NATION_CODE: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
        11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
        31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
        41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
        51, 52, 53, 54, 55, 56, 98, 99
      ],
      // 性别
      SEX_NAME: ['男', '女', '未说明的性别', '未知的性别'],
      SEX_CODE: ['1', '2', '9', '0'],
      // 婚姻
      MARRIAGE_NAME: ['未婚', '已婚', '丧偶', '离婚', '未说明的婚姻状况'],
      MARRIAGE_CODE: ['10', '21', '30', '40', '90'],
      // 表单数据
      formData: {
        orgId: '',
        orgName: '',
        teamId: '',
        teamName: '',
        manageOperator: '',
        manageStaffName: '',
        sickName: '',
        sickSex: '',
        birthday: '',
        identityCardNo: '',
        marriage: '',
        education: '',
        nation: '',
        sickWorkCompany: '',
        zoneCode: '',
        nativePlace: '',
        birthPlace: '',
        sickPhone: '',
        sickAddress: '',
        linkmanName: '',
        linkmanRelation: '',
        linkmanPhone: '',
        drugName1: '',
        drugUsage1: '',
        drugDosage1: '',
        drugName2: '',
        drugUsage2: '',
        drugDosage2: '',
        drugName3: '',
        drugUsage3: '',
        drugDosage3: '',
        fatherNone: '',
        fatherHypertension: '',
        fatherDiabetes: '',
        fatherCoronary: '',
        fatherAllergy: '',
        fatherMalignant: '',
        fatherStroke: '',
        fatherSchizophrenia: '',
        fatherTb: '',
        fatherHepatitis: '',
        fatherCongenital: '',
        fatherOther: '',
        fatherOtherContent: '',
        motherNone: '',
        motherHypertension: '',
        motherDiabetes: '',
        motherCoronary: '',
        motherAllergy: '',
        motherMalignant: '',
        motherStroke: '',
        motherSchizophrenia: '',
        motherTb: '',
        motherHepatitis: '',
        motherCongenital: '',
        motherOther: '',
        motheOtherContent: '',
        brothersNone: '',
        brothersHypertension: '',
        brothersDiabetes: '',
        brothersCoronary: '',
        brothersAllergy: '',
        brothersMalignant: '',
        brothersStroke: '',
        brothersSchizophrenia: '',
        brothersTb: '',
        brothersHepatitis: '',
        brothersCongenital: '',
        brothersOther: '',
        brothersOtherContent: '',
        childrenNone: '',
        childrenHypertension: '',
        childrenDiabetes: '',
        childrenCoronary: '',
        childrenAllergy: '',
        childrenMalignant: '',
        childrenStroke: '',
        childrenSchizophrenia: '',
        childrenTb: '',
        childrenHepatitis: '',
        childrenCongenital: '',
        childrenOther: '',
        childrenOtherContent: '',
        pastNone: '',
        pastHypertension: '',
        pastHypertensionDate: '',
        pastDiabetes: '',
        pastDiabetesDate: '',
        pastCoronary: '',
        pastCoronaryDate: '',
        pastCopd: '',
        pastCopdDate: '',
        pastMalignant: '',
        pastMalignantCon: '',
        pastMalignantDate: '',
        pastApoplexy: '',
        pastApoplexyDate: '',
        pastSchizophrenia: '',
        pastSchizophreniaDate: '',
        pastTb: '',
        pastTbDate: '',
        pastHepatitis: '',
        pastHepatitisDate: '',
        pastOficiala: '',
        pastOficialaCon: '',
        pastOficialaDate: '',
        occupationalDisease: '',
        occDiseaseCon: '',
        occupationalDiseaseDate: '',
        pastOther: '',
        pastOtherContent: '',
        pastOtherContentDate: '',
        height: '',
        waist: '',
        weight: '',
        systolic: '',
        diastolic: '',
        smokingCircumstance: '',
        dailySmokingQuantity: '',
        beginSmokingAge: '',
        quitSmokingAge: '',
        drinkFrequency: '',
        everyAlcoholTolerance: '',
        isDryOut: '',
        dryOutAge: '',
        beginDrinkAge: '',
        oneYearIsTemulentia: '',
        drinkWhiteSpirits: '',
        drinkBeer: '',
        drinkRedWine: '',
        drinkYellowWine: '',
        drinkOthers: '',
        drinkOthersStr: '',
        hardeningFrequency: '',
        everyHardeningTime: '',
        insistHardeningTime: '',
        hardeningMode: '',
        visionLeftEye: '',
        visionRightEye: '',
        straightenVisionLeftEye: '',
        straightenVisionRightEye: '',
        disabilityWithout: '',
      },

      // 表单验证规则
      formRules: {

      },

      // 提交状态
      submitLoading: false
    };
  },
  created() {
    const query = this.$route.query;
    this.orgId = query.orgId;
    this.getPageInfo();
  },
  methods: {

    // 获取页面需要的数据
    getPageInfo() {
      return this.request({
        method: 'post',
        url: '/webFill/service?method=webArchiveFill_getPageInfo',
        params: {
          'orgId': this.orgId
        }
      }).then((response) => {          //这里使用了ES6的语法
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if (response.code !== 0) {
          this.$message.error(response.msg);
          return false;
        }
        if (!!response.data && !!response.data.teamList) {
          this.teamList = response.data.teamList;
        }
      })

    },
    updateFormDataFromResponse(responseData) {
      if (!responseData) return;

      Object.keys(this.formData).forEach(key => {
        if (responseData.hasOwnProperty(key)) {
          this.formData[key] = responseData[key];
        }
      });
    },
    // 提交表单
    submitForm() {
      return this.$refs.archiveForm.validate().then(() => {
        if(!this.submitLoading){
          this.submitLoading = true;

          return this.request({
            method: 'post',
            url: '/webFill/save',
            params: this.formatThisFormData()
          }).then((response) => {
            this.submitLoading = false
            // 请求成功返回的数据
            //如果返回编码不为 0，提示失败语
            if (response.code !== 0) {
              this.$message.error(response.msg);
              throw new Error(response.msg); // 抛出错误以便捕获
            } else {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.$toast.success({
                    message: '感谢参与填写',
                    forbidClick: true,
                    duration: 0
                  });
                }
              })
            }
            return response; // 返回响应数据
          }).catch((error) => {
            this.submitLoading = false;
            throw error;
          });
        }

      }).catch((error) => {
        this.$message.warning('请完善必填信息:' + error[0].message);
        console.error('表单验证或提交失败:', error);
      });
    },

    //步骤条++
    stepsPlus() {
      return this.$refs.archiveForm.validate().then(() => {
        this.active++;
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }).catch((error) => {
        this.$message.warning('请完善必填信息:' + error[0].message);
        console.error('表单验证或提交失败:', error);
      });

    },
    //步骤条--
    stepsMinus() {
      if (this.active > 0) {
        this.active--;
      }
    },
    // 选择与本人关系
    pickWithHostRelation(value) {
      this.formData.linkmanRelation = value;
      this.showPickerWith = false
    },
    formatThisFormData() {
      const newData = JSON.parse(JSON.stringify(this.formData));
      if (!!newData.marriage) {
        const marriageIndex = this.MARRIAGE_NAME.indexOf(newData.marriage);
        if (marriageIndex !== -1) {
          newData.marriage = this.MARRIAGE_CODE[marriageIndex];
        }
      }
      if (!!newData.education) {
        const educationIndex = this.EDUCATION_NAME.indexOf(newData.education);
        if (educationIndex !== -1) {
          newData.education = this.EDUCATION_CODE[educationIndex];
        }
      }
      if (!!newData.nation) {
        const nationIndex = this.NATION_NAME.indexOf(newData.nation);
        if (nationIndex !== -1) {
          newData.nation = this.NATION_CODE[nationIndex];
        }
      }
      if (!!newData.linkmanRelation) {
        const relationIndex = this.HYGIENE_WITH_HOST_RELATION_DICT_NAME.indexOf(newData.linkmanRelation);
        if (relationIndex !== -1) {
          newData.linkmanRelation = this.HYGIENE_WITH_HOST_RELATION_DICT_CODE[relationIndex];
        }
      }
      if (!!newData.sickSex) {
        const sexIndex = this.SEX_NAME.indexOf(newData.sickSex);
        if (sexIndex !== -1) {
          newData.sickSex = this.SEX_CODE[sexIndex];
        }
      }
      if (!!newData.occupation) {
        const occupationIndex = this.OCCUPATION_NAME.indexOf(newData.occupation);
        if (occupationIndex !== -1) {
          newData.occupation = this.OCCUPATION_CODE[occupationIndex];
        }
      }

      return newData;
    },
    // 选择团队
    pickTeam(value) {
      this.formData.teamId = value;
      this.showPickerTeam = false
    },
    // 选择文化程度
    pickEducation(value) {
      this.formData.education = value;
      this.showPickerEducation = false
    },
    // 选择职业
    pickOccupation(value) {
      this.formData.education = value;
      this.showPickerOccupation = false
    },
    // 选择民族
    pickNation(value) {
      this.formData.nation = value;
      this.showPickerNation = false
    },
    // 选择民族
    pickSex(value) {
      this.formData.sickSex = value;
      this.showPickerSex = false
    },
    // 重置表单
    resetForm() {
      this.$refs.archiveForm.resetFields();
      // 清空非表单字段
      Object.keys(this.formData).forEach(key => {
        if (typeof this.formData[key] === 'string') {
          this.formData[key] = '';
        }
      });
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    onConfirm1(date) {  // 生日
      this.dateShow1 = false;
      this.formData.birthday = this.formatDate(date);
    },
    onConfirm2(date) { // 疾病史-高血压
      this.dateShow2 = false;
      this.formData.pastHypertensionDate = this.formatDate(date);
      this.formData.pastHypertension = 1 ;
    },
    onConfirm3(date) { // 疾病史-冠心病
      this.dateShow3 = false;
      this.formData.pastCoronaryDate = this.formatDate(date);
      this.formData.pastCoronary = 1 ;
    },
    onConfirm4(date) { // 疾病史-慢性阻塞性肺病
      this.dateShow4 = false;
      this.formData.pastCopdDate = this.formatDate(date);
      this.formData.pastCopd = 1 ;
    },
    onConfirm5(date) { // 疾病史-恶性肿瘤
      this.dateShow5 = false;
      this.formData.pastMalignantDate = this.formatDate(date);
      this.formData.pastMalignant = 1 ;
    },
    onConfirm6(date) { // 疾病史-脑卒中
      this.dateShow6 = false;
      this.formData.pastApoplexyDate = this.formatDate(date);
      this.formData.pastApoplexy = 1 ;
    },
    onConfirm7(date) { // 疾病史-严重精神障碍
      this.dateShow7 = false;
      this.formData.pastSchizophreniaDate = this.formatDate(date);
      this.formData.pastSchizophrenia = 1 ;
    },
    onConfirm8(date) { // 疾病史-结核病日期
      this.dateShow8 = false;
      this.formData.pastTbDate = this.formatDate(date);
      this.formData.pastTb = 1 ;
    },
    onConfirm9(date) { // 疾病史-肝炎
      this.dateShow9 = false;
      this.formData.pastHepatitisDate = this.formatDate(date);
      this.formData.pastHepatitis = 1 ;
    },
    onConfirm10(date) { // 疾病史-其他传染病
      this.dateShow10 = false;
      this.formData.pastOficialaDate = this.formatDate(date);
      this.formData.pastOficiala = 1 ;
    },
    onConfirm11(date) { // 疾病史-职业病
      this.dateShow11 = false;
      this.formData.occupationalDiseaseDate = this.formatDate(date);
      this.formData.occupationalDisease = 1 ;
    },
    onConfirm12(date) { // 疾病史-其他
      this.dateShow12 = false;
      this.formData.pastOtherContentDate = this.formatDate(date);
      this.formData.pastOther = 1 ;
    },
    onConfirm13(date) { // 疾病史-糖尿病
      this.dateShow13 = false;
      this.formData.pastDiabetesDate = this.formatDate(date);
      this.formData.pastDiabetes = 1 ;
    },
    // 快速切换年份（需要配合 ref 使用）
    changeYear(yearChange, calendarRef) {
      if (!calendarRef) return;
      let newDate = null;
      if (this.calendarTemp == null){
        newDate = new Date(calendarRef.currentDate);
      }else{
        newDate = this.calendarTemp;
      }
      newDate.setFullYear(newDate.getFullYear() + yearChange);

      // 检查是否超出范围
      const minDate = this.birthdayMinDate;
      const maxDate = new Date();

      if (newDate < minDate) {
        this.$toast('已经是最小日期了');
        return;
      }
      if (newDate > maxDate) {
        this.$toast('已经是最大日期了');
        return;
      }
      this.calendarTemp = newDate;
      calendarRef.scrollToDate(newDate);
    },
    validateAndExtractIdCard() {
      const idCard = this.formData.identityCardNo.trim();
      if (!idCard) return;
      const idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!idCardRegex.test(idCard)) {
        this.$toast('身份证号格式不正确');
        return;
      }
      let birthday = '';
      let birthdayDate = null;
      if (idCard.length === 18) {
        // 18 位身份证：第 7-14 位是出生日期
        const year = idCard.substring(6, 10);
        const month = idCard.substring(10, 12);
        const day = idCard.substring(12, 14);
        birthday = `${year}-${month}-${day}`;
        birthdayDate = new Date(year, parseInt(month) - 1, parseInt(day));
      } else if (idCard.length === 15) {
        // 15 位身份证：第 7-12 位是出生日期（年份前两位默认为 19）
        const year = '19' + idCard.substring(6, 8);
        const month = idCard.substring(8, 10);
        const day = idCard.substring(10, 12);
        birthday = `${year}-${month}-${day}`;
        birthdayDate = new Date(year, parseInt(month) - 1, parseInt(day));
      }

      // 填充出生日期字段
      if (birthday && birthdayDate) {
        this.formData.birthday = birthday;
        this.$refs.calendar1.reset(birthdayDate)
        this.birthdayMinDate = birthdayDate;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.web-archive-fill-container {
  width: 100%;
  max-width: 100vw;
  margin: 0;
  padding: 0;
  background-color: #f7f8fa;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  * {
    box-sizing: border-box;
  }
}

.page-header {
  padding: 12px 16px;
  background-color: #fff;
  margin-bottom: 8px;
  width: 100%;

  .page-title {
    font-size: 17px;
    font-weight: 600;
    color: #323233;
    margin: 0 0 8px 0;
    text-align: center;
  }

  .org-info {
    p {
      margin: 4px 0;
      font-size: 12px;
      color: #C8C9CC;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.steps-container {
  padding: 12px 8px;
  background-color: #fff;
  margin-bottom: 8px;
  width: 100%;
  //::v-deep .van-step--horizontal.van-step__icon {
  //  display: block;
  //  font-size: 22px !important;
  //}
}

.form-wrapper {
  width: 100%;
  margin: 0 8px 8px 8px;
  border-radius: 8px;
  overflow: visible;

  ::v-deep .van-cell {
    padding: 10px 16px;

    &::after {
      left: 16px;
    }
  }

  ::v-deep .van-field__label {
    font-size: 14px;
    color: #323233;
    width: 85px;
    flex-shrink: 0;
  }

  ::v-deep .van-field__control {
    font-size: 14px;
    flex: 1;
    min-width: 0;
  }
}

.step-navigation {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 16px;
  margin: 0 8px 16px 8px;
  background-color: #fff;
  border-radius: 8px;
  width: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .van-button {
    flex: 1;
    max-width: none;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
  }
}

.error-content {
  padding: 16px;

  .error-icon {
    color: #f44;
    margin-right: 8px;
  }

  .error-details {
    margin-top: 12px;
    padding: 12px;
    background-color: #f7f8fa;
    border-radius: 4px;

    p {
      margin: 4px 0;
      color: #666;
      font-size: 14px;
    }
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .web-archive-fill-container {
    width: 100vw;
    max-width: 100vw;
    height: auto;
    min-height: 100vh;
  }

  .page-header {
    .page-title {
      font-size: 16px;
    }
  }

  .form-wrapper {
    ::v-deep .van-field__label {
      width: 75px;
      font-size: 13px;
    }
  }

  .step-navigation {
    .van-button {
      font-size: 13px;
      height: 34px;
      line-height: 34px;
    }
  }
}

// 小屏幕手机
@media screen and (max-width: 375px) {
  .form-wrapper {
    ::v-deep .van-field__label {
      width: 65px;
      font-size: 12px;
    }

    ::v-deep .van-field__control {
      font-size: 13px;
    }
  }

  .step-navigation {
    .van-button {
      font-size: 12px;
      height: 32px;
      line-height: 32px;
    }
  }
}

// 关键：确保弹窗正常显示
::v-deep .van-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

::v-deep .van-popup {
  position: fixed;
  max-height: 50vh;
}

::v-deep .van-calendar {
  position: fixed;
  max-height: 60vh;
}

// 日历标题带按钮样式
.calendar-title-with-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 8px;

  .calendar-title-text {
    font-size: 14px;
    font-weight: 500;
    color: #323233;
  }

  .van-button {
    min-width: 28px;
    height: 28px;
    border-color: #dcdee0;

    &:active {
      background-color: #f2f3f5;
    }
  }
}
.button-row {
  display: flex;
  gap: 8px;
  padding: 12px 16px;

  .van-button {
    flex: 1;
    min-width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/web/fill/archive/index.vue